(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.getElementById("sp-menu-hamburger").addEventListener("click", () => {
    document.getElementById("sp-menu").classList.toggle("hidden");
  });

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if(!this.searchModal)
        return;
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jisha-book-goods-image-ad"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', async () => {
  const setClickAdvertisement = (advertisingName) => {
    window?._paq?.push(['trackEvent', 'Advertisement', 'Click', advertisingName]);
  };
  const setViewAdvertisement = (advertisingName) => {
    window?._paq?.push(['trackEvent', 'Advertisement', 'View', advertisingName]);

    try {
      gtag('event', 'view_ad', {
        advertiser_name: advertisingName
      });
    } catch(e) {
      console.log('not defined gtag')
    }
  };

  const clickAd = (url, advertisingName) => {
    setClickAdvertisement(advertisingName);

    try {
      gtag('event', 'click_ad', {
        advertiser_name: advertisingName
       });
    } catch(e) {
      console.log('not defined gtag')
    }

    if(url.indexOf("http") === -1){
      window.open(url, '_self');
      return false;
    }

    // 別タブでURLを開く
    window.open(url, '_blank');

    return false;
  };

  const getAdvertisingData = async (area) => {
    const url  = `${window.jishaConfig.ADVERTISING_DATA_END_POINT}?section=${area}&_=${new Date().getTime()}`;
    const response = await fetch(url, {
      method: 'GET',
      cache: "no-store",
      headers: {
        'Content-Type': 'application/json',
      },
    });
    const result = await response.json();
    return result.advertisements;
  };

  const advertisements = await getAdvertisingData("bottom");
  if(!advertisements) return;
  const ulElement = document.getElementById('ad-bottom');
  advertisements.forEach(ad => {
    const liElement = document.createElement('li');
    liElement.setAttribute('data-advertising-name', ad.label);
    const linkElement = document.createElement('a');
    linkElement.href = ad.link_url;
    linkElement.className = 'w-full';
    linkElement.addEventListener('click', function(e) {
      clickAd(ad.link_url, ad.label);
      e.stopPropagation();
      e.preventDefault();
    });

    const imgElement = document.createElement('img');
    imgElement.src = ad.image_url;
    imgElement.className = 'w-full';
    imgElement.alt = ad.alt;

    setViewAdvertisement(ad.label);

    linkElement.appendChild(imgElement);
    liElement.appendChild(linkElement);
    ulElement.appendChild(liElement);
  });

});

  } catch(e) { console.error(e); }
})();
})();
